import {
  ChakraProvider,
  createSystem,
  defaultConfig,
  defineConfig,
} from "@chakra-ui/react";
import { Button, Link } from "./recipes";

// custom theme
const customConfig = defineConfig({
  globalCss: {
    "html, body": {
      bgColor: "black",
    },
    canvas: {
      left: 0,
      top: 0,
      pos: "fixed",
      pointerEvents: "none",
      height: "100vh",
      width: "100vw",
    },
  },
  theme: {
    tokens: {
      fonts: {
        body: {
          value: '"Roboto Condensed", sans-serif',
        },
      },
      colors: {
        violet: {
          400: { value: "#c077ff" },
          500: { value: "#9855d4" },
          600: { value: "#6c1bb5" },
        },
      },
    },
    recipes: {
      ...Button,
      ...Link,
    },
    keyframes: {
      "fade-in-out": {
        "0%": { opacity: 0 },
        "50%": { opacity: 1 },
        "100%": { opacity: 0 },
      },
      "hero-rise": {
        "0%": { opacity: 0, transform: "translateY(24px)" },
        "100%": { opacity: 1, transform: "translateY(0)" },
      },
      "fade-up": {
        "0%": { opacity: 0, transform: "translateY(16px)" },
        "100%": { opacity: 1, transform: "translateY(0)" },
      },
      "scroll-bounce": {
        "0%": { opacity: 0, transform: "translateY(0)" },
        "40%": { opacity: 1 },
        "80%": { opacity: 0, transform: "translateY(10px)" },
        "100%": { opacity: 0, transform: "translateY(10px)" },
      },
    },
  },
});

// Create system for typegen and provider
export const system = createSystem(defaultConfig, customConfig);

export function Provider({ children }: React.PropsWithChildren) {
  return <ChakraProvider value={system}>{children}</ChakraProvider>;
}

export default system;
